import script from "./InfrastructureView.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfrastructureView.vue?vue&type=script&setup=true&lang=ts"

import "./InfrastructureView.vue?vue&type=style&index=0&id=4c2998b4&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c2998b4"]])

export default __exports__